<div class="row mb-0 mt-2 pb-0 alert alert-info rounded-bottom">
  <strong>{{ 'missing-document-message.title' | translate }}</strong>
  <p>{{ 'missing-document-message.text-footer' | translate }}</p>
</div>
